import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Text, Icon, Block } from '../../../../../components';
import DateHelpers from '../../../../../../core/helpers/DateHelper';
import { useWindowSize } from '@/core/hooks/useWindowSize';

const Container = styled.button.attrs((props: any) => ({
  aLine: props.aLine
}))`
  background-color: #fff;
  padding: ${({ aLine }) => (aLine ? '20px 16px' : '12px 16px')};
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
  flex-direction: row;
  cursor: pointer;
  &:hover {
    background-color: var(--buton-icon-hover);
  }
  &:focus {
    background-color: var(--button-icon-focus);
  }

  @media (min-width: 992px) and (max-width: 1279px) {
    width: 344px;
  }

  @media (min-width: 1280px) {
    width: 368px;
  }
`;

const Procedure = (props: any) => {
  const { onClick, title, deadline, isNew, isExternal } = props;
  const paragraphRef = useRef<HTMLParagraphElement>(null);
  const [lineCount, setLineCount] = useState(1);
  const { width } = useWindowSize();

  useEffect(() => {
    const element = paragraphRef.current;
    if (element) {
      const totalHeight = element.scrollHeight;
      const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
      const lines = Math.ceil(totalHeight / lineHeight);
      setLineCount(lines);
    }
  }, [width]);

  let endDate = '';
  if (deadline) {
    const arrDate = deadline.split('-');
    const date = new Date(arrDate[0], arrDate[1] - 1, arrDate[2]);
    endDate = DateHelpers.formatDate(date.getTime()) || '';
  }
  return (
    <Container
      className={`fadeTransition ${isExternal ? 'external' : ''}`}
      data-testid="cmp-procedure-card"
      aLine={lineCount === 1}
      onClick={onClick}
    >
      <Block customized style={{ marginRight: '16px' }}>
        <p
          style={{
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: '700',
            color: '#161D1F',
            display: '-webkit-box',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'start'
          }}
          ref={paragraphRef}
        >
          {title}
        </p>
        {deadline && (
          <Block
            customized
            flexDirection="row"
            alignContent="flex-start"
            margin="6px 0px 0px 0px"
          >
            <Text
              fontSize="12px"
              lineHeight="16px"
              fontWeight="400"
              color="var(--text-text01)"
            >
              <b>Fecha límite:</b> {endDate?.toLowerCase() || ''}
            </Text>
          </Block>
        )}
      </Block>
      {isNew && (
        <span
          style={{
            backgroundColor: '#5b36f2',
            borderRadius: '20px',
            marginLeft: 'auto',
            marginRight: '8px',
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: '700',
            padding: '4px 12px'
          }}
        >
          Nuevo
        </span>
      )}

      <Icon
        name={isExternal ? 'external-link' : 'chevron-right'}
        color="#5B36F2"
        size="24"
      />
    </Container>
  );
};

export default Procedure;
